<div class="dropzone py-5 px-3" fileDnd (files)="appendFiles($event)" [class.invalid]="control.invalid && submitAttempt">
  <input type="file" name="files[]" [multiple]="multiple" [accept]="accept" fileInputChange
    (files)="appendFiles($event)">
  <div class="info">
    @if(label) {
    <p class="label mb-3">{{label}}</p>
    }
    @if(showIllustration) {
      <img class="mb-3" src="/assets/animations/illustrations/file-upload.svg" alt="File upload illustration">
    }
    <ng-content></ng-content>
    <p>
      <b [style.color]="accentColor"><fa-icon class="me-1" [icon]="faPaperclip"></fa-icon>{{'ct-library.file-input.primary' | transloco}}</b>
      {{'ct-library.file-input.secondary' | transloco}}
    </p>
    <p class="restrictions mt-3">
      {{'ct-library.file-input.max-file-size' | transloco:
      {
      maxFileSize: getFileSizeLimitInMb(),
      }
      }}
      @if(accept !== '*' && showAcceptLabel) {
      <br>
      {{'ct-library.file-input.allowed-file-types' | transloco:
      {
      allowedFileType: accept,
      }
      }}
      }
    </p>
  </div>
</div>
@for (file of files; track file.name) {
  <div class="file-preview py-2 px-3 mt-2 gap-2">
    <p><b>{{file.name}}</b></p>
    <fa-icon class="text-red" [icon]="faTrash" (click)="removeFile(file);"></fa-icon>
  </div>
}